import styled from "styled-components";

export const NewSessionButtonContainer = styled.div``;
